import { loadAutoSubscriptionModal } from "@components/modal/subscriptionProposal";
import { loadUpdatePasswordModal } from "@components/modal/updatePassword/loader";
import { loadWelcomeOrConfirmationReminderModal } from "@components/modal/welcomeOrConfirmationReminder/loader";
import OnboardingTooltipComponent from "@components/onBoardingTooltip";
import NotificationAlert from "@components/notificationAlert";
import AFSClickTracker from "@libs/afs-click-tracker";
import { readCookie } from "@utils/cookie";
import GoogleOneTapLoader from "./google-one-tap-loader";
import { pushEvent } from "./gtm-service";
import { JtagService } from "./jtag-service";
import { promptPushnamiNotification } from "./notification-service";
import { getQueryStringParams } from "./referrer-service";


export default class PageLoaderService {
  private static jrConfigGlobal: JrConfigGlobal = window.jrConfigGlobal;

  public static init = (): void => {
    const { page: { isSearch = false } } = PageLoaderService.jrConfigGlobal;

    PageLoaderService.loadCommons();

    if (isSearch) {
      PageLoaderService.loadSerp();
    }
  }

  private static loadSerp() {
    const {
      feature: { notificationAlertBoxEnabled = false },
      user: { mail = '', subscribedEmail = '' },
      showActivateProfileConfirmDialog = false,
      visit: { requestComingFromWelcomeEmailAddPassword = false, isOneTapConfirmationFlow = false },
      onboardingTooltipEnabled = false
    } = PageLoaderService.jrConfigGlobal;

    if (notificationAlertBoxEnabled) {
      new NotificationAlert().init();
    }

    if (showActivateProfileConfirmDialog || requestComingFromWelcomeEmailAddPassword) {
      pushEvent({ event: 'jobseekerConfirm' });

      if (isOneTapConfirmationFlow) {
        const jobseekerEmail = mail || subscribedEmail;

        loadWelcomeOrConfirmationReminderModal({
          emailAddress: jobseekerEmail,
          source: 'google_one_tap',
        });
      } else {
        loadUpdatePasswordModal();
      }

      JtagService.trackCustomEvent('impression_confirmation_popup');
    }

    if (onboardingTooltipEnabled) {
      new OnboardingTooltipComponent().init();
    }
  }

  private static loadCommons() {
    const {
      canShowSubscriptionPopup = false,
      feature: { singleOptInWelcomePopupEnabled = false },
      user: { isJobSeeker = false, },
      modal: { confirmReminderMaxTimes = 0 },
      pushNotifications: { active: pushnamiNotificationActive = false },
      registeredJobseeker: { confirmed: jobseekerIsConfirmed = false, email: jobseekerEmail = '' }
    } = PageLoaderService.jrConfigGlobal;

    loadAutoSubscriptionModal();

    if (singleOptInWelcomePopupEnabled) {
      const queryParams = getQueryStringParams(window.location.search);

      if (queryParams.email) {
        loadWelcomeOrConfirmationReminderModal({
          emailAddress: queryParams.email,
          source: 'welcome'
        });
      }
    }

    AFSClickTracker.Track();

    GoogleOneTapLoader.load();

    if (pushnamiNotificationActive && isJobSeeker && !canShowSubscriptionPopup) {
      promptPushnamiNotification();
    }

    if (!jobseekerIsConfirmed && jobseekerEmail) {
      const cookieName = 'confirmReminderModalCount';

      const popupMaxCount = confirmReminderMaxTimes;
      const count = readCookie(cookieName) || '0';
      if (parseInt(count, 10) < popupMaxCount) {
        loadWelcomeOrConfirmationReminderModal({ emailAddress: jobseekerEmail, source: 'confirmation_reminder' })
      }
    }
  }
}